/* eslint-disable @typescript-eslint/no-unused-vars */
export const sanitizeInputRestProps = ({
  afterSubmit,
  allowNull,
  alwaysOn,
  beforeSubmit,
  component,
  data,
  defaultValue,
  error,
  format,
  formatOnBlur,
  initializeForm,
  input,
  isEqual,
  isRequired,
  label,
  limitChoicesToValue,
  locale,
  meta,
  multiple,
  name,
  options,
  optionText,
  optionValue,
  parse,
  record,
  ref,
  refetch,
  render,
  resource,
  setFilter,
  setPagination,
  setSort,
  shouldUnregister,
  source,
  submitError,
  subscription,
  textAlign,
  translate,
  translateChoice,
  validate,
  validateFields,
  value,
  ...rest
}: any) => rest;
